<template>
  <DialogBase 
    :isDialogVisible="dialogOpen"
    :dialogWidth="450"
  >
    <template v-slot:header>
      <span>Complete Task?</span>
    </template>

    <template v-slot:content>
      <p>Marking this task as completed will also complete it for everyone else who is assigned.</p>
    </template>

    <template v-slot:footer>
      <v-btn
        text="Cancel"
        variant="text"
        @click="closeDialog"
      ></v-btn>
      <v-btn
        :loading="isConfirmBtnLoading"
        text="Confirm"
        append-icon="mdi-check"
        color="primary"
        variant="tonal"
        @click="completeTask"
      ></v-btn>
    </template>
  </DialogBase>
</template>
  
<script>

import api from '@/services/api';
import DialogBase from './DialogBase.vue';
import eventBus from '@/services/eventBus';

  export default {
    name: 'TaskConfirmationDialog',
    components: {
      DialogBase
    },
    props: {
      isDialogOpen: {
        type: Boolean,
        default: false
      },
      targetTask: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        hasConfirmed: false,
        isConfirmBtnLoading: false,
        isLightMode: true,
      }
    },
    methods: {
      closeDialog() {
        this.dialogOpen = false;
      },
      async completeTask() {
        this.isConfirmBtnLoading = true;

        try {
          await api.post(`/UserTask/UpdateUserTaskStatus`, null, {
            params: {
              taskId: this.targetTask.user_Task_ID,
              status: "Completed",
            },
          });

          await new Promise(resolve => setTimeout(resolve, 700));
          
          this.showSnackbar('success', 'mdi-check-circle', 'Successfully Changed Task Status.', 'Task ' + this.targetTask.user_Task_ID + ' was changed to completed');
          eventBus.emit('taskAssigned');
          this.$emit('refresh-tasks')
  
        } catch (error) {
          console.error(error);
          this.showSnackbar('error', 'mdi-alert-circle', 'An Error Occured Completing Task', 'Task ' + this.targetTask.user_Task_ID + ' could not be updated.');
        } finally {
          this.isConfirmBtnLoading = false;
          this.closeDialog();
        }
      },
      showSnackbar(color, icon, title, description) {
        this.$emit('show-snackbar', {
          color,
          icon,
          title,
          description,
        });
      },
    },
    computed: {
      dialogOpen: {
        get() {
          return this.isDialogOpen;
        },
        set(value) {
          this.$emit('update:is-dialog-open', value);
        }
      }
    }
  }
</script>
